import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-blog-details-left-sidebar',
  templateUrl: './breadcrumb-blog-details-left-sidebar.component.html',
  styleUrls: ['./breadcrumb-blog-details-left-sidebar.component.css']
})
export class BreadcrumbBlogDetailsLeftSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
